import { render, staticRenderFns } from "./newsBox.vue?vue&type=template&id=213d1c54&"
import script from "./newsBox.vue?vue&type=script&lang=ts&"
export * from "./newsBox.vue?vue&type=script&lang=ts&"
import style0 from "./newsBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports